import { Organization } from "./Organization";
import { Queue } from "./Queue";
import type { SavedSticker } from "../services/savedStickerServices";

export enum UserRole {
  ADMIN = "ADMIN",
  MANAGER = "MANAGER",
  ATTENDANT = "ATTENDANT",
};

export type ProductID = "VOID_CHAT" | "VOID_LINX" | "VOID_SEND" | "VOID_PAYMENT";

export type EntitlementStatus = "TRIAL" | "ACTIVE" | "PAST_DUE" | "SUSPENDED" | "CANCELED" | "EXPIRED" | "NOT_CONTRACTED";

export type UserProductAccess = "ALLOWED" | "DENIED";

export interface ProductAccessContext {
  organizationId: string;
  productId: ProductID;
  entitlementStatus: EntitlementStatus;
  userAccess: UserProductAccess;
  assignedRole: UserRole;
};

export interface User {
  id: string;
  name: string;
  email: string;
  isOnline?: boolean;
  role: UserRole;
  avatar?: string | null;
  organization: Organization;
  queues?: Array<Queue>;
  savedStickers?: Array<SavedSticker>;
};

export interface AuthUser extends User {
  token?: string;
  access?: ProductAccessContext;
};
